import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { TaxReasonFormSchemaValues } from 'src/features/taxReasons/utils/formSchema';
import { TaxReason } from 'src/features/taxReasons/utils/types';

const RESOURCE = '/subscriptions/tax-reason/:id/';

type MutationFnType = typeof mutationFn;

interface DTO extends TaxReasonFormSchemaValues {
    id: string;
}
const mutationFn = ({ id, ...data }: DTO): Promise<TaxReason> => {
    return axios.put(formatResourcePath(RESOURCE, { id }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateTaxReason };
